import script from "./ExamManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamManagement.vue?vue&type=script&setup=true&lang=js"

import "./ExamManagement.vue?vue&type=style&index=0&id=05890d6d&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05890d6d"]])

export default __exports__